import { render } from "./CmsLinkComponent.vue?vue&type=template&id=50f0d143"
import script from "./CmsLinkComponent.vue?vue&type=script&lang=js"
export * from "./CmsLinkComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__